import 'css-chunksrc/feature/pay-in-out/PayInOutPage.module.scss';export default {
  "root": "PayInOutPage_root"
};